import { IFuncUpdater } from 'ahooks/lib/createUseStorageState'

export const emptyFileState = {
  files: [],
}

export interface FileState {
  files: any[]
}

export type FileSetState = (value: FileState | IFuncUpdater<FileState>) => void
